module.exports = __webpack_public_path__ + "static/media/Prof_alumnos.96996b17.jpg";